// Footer.js
import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { AiOutlineCalendar } from "react-icons/ai";
import { BsPersonCircle } from "react-icons/bs";
import { GiMedicines } from "react-icons/gi";

const Footer = () => {
  const location = useLocation();

  console.log("Current Path:", location.pathname);


  const renderFooterContent = () => {
    const validPaths = [
      '/mypage/reservation',
      '/mypage/history',
      '/mypage/order',
      '/mypage/other',
      '/medicine',
      '/medicine/inspection',
      '/',
      '/index.html',
      '/reserve'
    ];
  
    if (validPaths.includes(location.pathname)) {
      return (
        <nav className="footer_content_page">
          <NavLink
            to="/reserve"
            className={({ isActive }) => (isActive ? 'footer_content active' : 'footer_content')}
          >
            <AiOutlineCalendar className="footer_icon" />
            <p className="footer_p">診察予約</p>
          </NavLink>
          <NavLink
            to="/medicine"
            className={({ isActive }) => (isActive ? 'footer_content active' : 'footer_content')}
          >
            <GiMedicines className="footer_icon" />
            <p className="footer_p">お薬管理</p>
          </NavLink>
          <NavLink
            to="/mypage/reservation"
            className={location.pathname.startsWith('/mypage') ? 'footer_content active' : 'footer_content'}
          >
            <BsPersonCircle className="footer_icon" />
            <p className="footer_p">マイページ</p>
          </NavLink>
        </nav>
      );
    }
    return null;
  };
  
  

  return (
    <div className="footer">
      {renderFooterContent()}
    </div>
  );
};

export default Footer;